export enum StorageKeys {
    TOKEN="TOKEN",
    REFRESH_TOKEN="REFRESH_TOKEN",
    IS_COOKIES_AGREED="IS_COOKIES_AGREED",
    APP_STATE="APP_STATE",
    RECOMMENDATIONS_STORAGE_NAME="RECOMMENDATION"
}